export type Bonus = {
  number: string
  name: string
  summary: string
  pages: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Patient Assessment & Progress Tracking Toolkit',
    summary: 'Professional assessment forms, symptom records, functional tracking sheets, and reassessment resources.',
    pages: '40 pages of professional documentation tools',
    value: 12,
  },
  {
    number: '02',
    name: 'Customizable Exercise Prescription & Session Planner',
    summary: 'Customizable exercise cards, session planners, dosage tables, and patient exercise handouts.',
    pages: '40 pages of prescription and planning resources',
    value: 12,
  },
  {
    number: '03',
    name: 'Exercise Regression & Progression Visual Library',
    summary:
      '20 exercise families with 60 practical variations, showing easier, standard, and more demanding exercise options.',
    pages: '40 pages of visual exercise adaptations',
    value: 15,
  },
  {
    number: '04',
    name: 'Home Rehabilitation Programs & Patient Exercise Plans',
    summary: '12 complete home programs with step-by-step instructions, sets, repetitions, rest, and weekly routines.',
    pages: '40 pages of home rehabilitation resources',
    value: 12,
  },
  {
    number: '05',
    name: 'Clinical Decision-Making & Rehabilitation Progression Checklists',
    summary:
      'Practical checklists and decision guides for adjusting exercises, modifying loads, and determining when reassessment is appropriate.',
    pages: '40 pages of professional clinical decision tools',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const checkoutFeatures = [
  '80 detailed exercises',
  '48 structured rehabilitation sessions',
  '12 individualized patient-based programs',
  'Step-by-step movement instructions',
  'Sets, repetitions, and rest periods',
  'Exercise regressions and progressions',
  'Mobility, strength, and functional rehabilitation',
  'Five professional bonuses — $61 USD FREE',
  'Instant digital access',
  '7-day guarantee',
]
